module.exports = __webpack_public_path__ + "media/super6.6726f9d1.mp3";